import { render, staticRenderFns } from "./unreceived-products.vue?vue&type=template&id=1f55bfe5"
import script from "./unreceived-products.vue?vue&type=script&lang=js"
export * from "./unreceived-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports